import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CouponLinkTemplate } from 'components/Templates'

const CouponLink: FC = () => {
  return (
    <Layout headline={'クーポン'} iconPath={'/icon/white/coupon.svg'} title={'ユーザー紐付け | クーポン一覧'}>
      <CouponLinkTemplate />
    </Layout>
  )
}

export default CouponLink
